import { Button, Form, Input, Modal } from "antd";
import { useState } from "react";

const LinkPaymentModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleLinkPayment = () => {}
}) => {
  const [form] = Form.useForm();
  const [setTypeValue] = useState(null);

  return (
    <Modal
      title="Link Payment to Subscription"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => setIsModalOpen(false)}
      onCancel={() => setIsModalOpen(false)}
    >
      <Form
        form={form}
        name="link_payment_form"
        onFinish={handleLinkPayment}
        onValuesChange={(changedValues) => {
          if (changedValues.type) {
            setTypeValue(changedValues.type);
            form.validateFields();
          }
        }}
      >
        <Form.Item
          name="razorpayOrderId"
          label="RazorPay Order ID"
          rules={[
            { required: true, message: "Please enter the RazorPay Order ID!" },
            { pattern: /^order_[a-zA-Z0-9]{14,}$/, message: "Invalid RazorPay Order ID format!" }
          ]}
        >
          <Input placeholder="order_XXXX" />
        </Form.Item>

        <Form.Item
          name="razorpayPaymentId"
          label="RazorPay Payment ID"
          rules={[
            { required: true, message: "Please enter the RazorPay Payment ID!" },
            { pattern: /^pay_[a-zA-Z0-9]{14,}$/, message: "Invalid RazorPay Payment ID format!" }
          ]}
        >
          <Input placeholder="pay_XXXX" />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Link Payment
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LinkPaymentModal;
